import { render, staticRenderFns } from "./hours.vue?vue&type=template&id=31937001&scoped=true&"
import script from "./hours.vue?vue&type=script&lang=ts&"
export * from "./hours.vue?vue&type=script&lang=ts&"
import style0 from "./hours.vue?vue&type=style&index=0&id=31937001&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31937001",
  null
  
)

export default component.exports